import type { ReactiveController, ReactiveControllerHost } from 'lit';
import type { Atom } from './store.ts';

/**
 * Subscribes a Lit component to one or more Atoms. Each fires
 * `host.requestUpdate()` whenever any of the atoms change.
 */
export class StoreController implements ReactiveController {
  private unsubs: Array<() => void> = [];

  constructor(
    private host: ReactiveControllerHost,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private atoms: ReadonlyArray<Atom<any>>,
  ) {
    host.addController(this);
  }

  hostConnected(): void {
    for (const a of this.atoms) {
      this.unsubs.push(a.subscribe(() => this.host.requestUpdate()));
    }
  }

  hostDisconnected(): void {
    for (const u of this.unsubs) u();
    this.unsubs = [];
  }
}
